document.querySelectorAll('[data-gallery]').forEach(gallery=>{
  const main=gallery.querySelector('[data-main-image]');
  const cover=gallery.querySelector('[data-set-cover]');
  const buttons=gallery.querySelectorAll('.thumbnail');
  gallery.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>{
    if(!main)return;
    main.src=button.dataset.image; main.alt=button.querySelector('img').alt;
    main.hidden=false; if(cover)cover.hidden=true;
    buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  }));
  const showSet=gallery.querySelector('[data-show-set]');
  if(showSet)showSet.addEventListener('click',()=>{
    cover.hidden=false; main.hidden=true;
    buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===showSet)));
  });
});
document.querySelectorAll('[data-variants]').forEach(select=>select.addEventListener('change',()=>{
  const option=select.selectedOptions[0], form=select.closest('form');
  const button=form.querySelector('button[type=submit]');
  button.disabled=option.dataset.available!=='true';
  button.textContent=option.dataset.available==='true'?'Add to bag':'Sold out';
  const scope=form.closest('.bundle-info,.product-info');
  const price=scope?.querySelector('[data-product-price]');
  if(price)price.firstChild.textContent=option.dataset.price;
}));
document.querySelectorAll('[data-preview-bundle]').forEach(form=>form.addEventListener('submit',event=>{
  event.preventDefault();
  const quantity=Number(form.querySelector('[name=quantity]').value);
  if(!Number.isInteger(quantity)||quantity<1)return;
  const count=document.querySelector('[data-preview-count]');
  if(count)count.textContent=String(Number(count.textContent)+quantity);
  form.querySelector('[data-preview-message]').textContent=quantity+' Faith Set'+(quantity===1?'':'s')+' added in this design preview. Live checkout will be connected in Shopify.';
}));
